import getCookie from "helpers/getCookie";

export const parseUTMCookie = (cookieStr: string) => {
  const params: any = {};
  cookieStr.split("|").forEach((pair) => {
    const [key, value] = pair.split("=");
    if (key) params[key] = value || "";
  });
  return params;
};

export const getUtmParams = (urlParams: URLSearchParams, initialUtmParamsFromCookie = "") => {
  const utmParamsCookies = initialUtmParamsFromCookie || getCookie("initial_utm_params") || "";
  const parsedUtmParams = parseUTMCookie(utmParamsCookies);

  const utmSource = urlParams?.get("utm_source") || parsedUtmParams?.utm_source || "";
  const utmMedium = urlParams?.get("utm_medium") || parsedUtmParams?.utm_medium || "";
  const campaign = urlParams?.get("utm_campaign") || parsedUtmParams?.utm_campaign || "";

  return { utmSource, utmMedium, campaign };
};

// A partner can switch the referral card off ("Show Referral Card" in the partner settings,
// stored as config.is_referral_card_enabled). On amberstudent.com only an explicit false hides
// the card: partners that never touched the switch keep seeing it (POD3-0, FR-5/FR-6).
export const isPartnerReferCardHidden = (partnerData: any): boolean =>
  partnerData?.config?.is_referral_card_enabled === false;
